export default "__VITE_ASSET__JMFd_XjK__"